import {
  LOGGED_OUT_ABOUT_VIEW,
  ACCOUNT_HOME_VIEW,
  LOGGED_OUT_FOR_PROVIDERS_VIEW,
  LOGGED_OUT_FIND_CARE_VIEW,
} from '../components/Account/util/views';
import addYourAvailability from './addYourAvailability';
import videoVisit from './videoVisit';
import cdp from './cdp/routing';
import embed from './embed';
import account from './account';
import redir from './redir';
import handoff from './handoff';

const routes = {
  path: '/',
  children: [
    {
      path: '/',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
      tabId: LOGGED_OUT_FIND_CARE_VIEW,
    },
    {
      path: '/dfw',
      load: () => import(/* webpackChunkName: 'dfwHome' */ './dfw'),
    },
    {
      path: '/add-insurance/:origin',
      load: () => import(/* webpackChunkName: 'addInsurance' */ './addInsurance'),
    },
    {
      path: '/add-insurance/:insuranceType/:origin',
      load: () => import(/* webpackChunkName: 'addInsurance' */ './addInsurance'),
    },

    {
      path: '/activate-feature-flag/:flag',
      load: () => import(/* webpackChunkName: 'activateFeatureFlag' */ './activateFeatureFlag'),
    },
    {
      path: '/search',
      load: () => import(/* webpackChunkName: 'searchRouter' */ './searchRouter'),
      tabId: ACCOUNT_HOME_VIEW,
    },
    {
      path: '/confirm',
      load: () => import(/* webpackChunkName: 'confirmation' */ './confirmation'),
      exportName: 'confirm',
    },
    {
      path: '/finalize',
      load: () => import(/* webpackChunkName: 'confirmation' */ './confirmation'),
      exportName: 'finalize',
    },
    {
      path: '/profile',
      load: () => import(/* webpackChunkName: 'profile' */ './profile'),
    },
    {
      path: '/symptoms',
      load: () => import(/* webpackChunkName: 'symptoms' */ './symptoms'),
    },
    {
      path: '/pass/:id',
      load: () => import(/* webpackChunkName: 'pass' */ './pass'),
    },
    {
      path: '/c/:id',
      load: () => import(/* webpackChunkName: 'pass' */ './pass'),
      exportName: 'passConfirmationShortUrl',
    },
    {
      path: '/r/:id',
      load: () => import(/* webpackChunkName: 'pass' */ './pass'),
      exportName: 'passReminderShortUrl',
    },
    {
      path: '/select-time/:nextPage(.*)',
      load: () => import(/* webpackChunkName: 'selectTime' */ './selectTime'),
    },
    {
      path: '/privacy',
      load: () => import(/* webpackChunkName: 'privacy' */ './privacy'),
    },
    {
      path: '/l/:locationId',
      load: () => import(/* webpackChunkName: 'waitList' */ './waitList'),
      exportName: 'locationWaitList',
    },
    {
      path: '/b/:bookingId',
      load: () => import(/* webpackChunkName: 'waitList' */ './waitList'),
      exportName: 'bookingWaitList',
    },
    {
      path: '/t/**',
      load: () => import(/* webpackChunkName: 'tracking' */ './tracking'),
    },
    {
      path: '/feedback',
      load: () => import(/* webpackChunkName: 'feedback' */ './feedback'),
    },
    {
      path: '/review-calculator',
      load: () => import(/* webpackChunkName: 'reviewCalculator' */ './reviewCalculator'),
    },
    account,
    {
      path: '/sign-up',
      children: [
        {
          path: '/',
          load: () => import(/* webpackChunkName: 'signUp' */ './signUp'),
          exportName: 'signUp',
        },
      ],
    },
    {
      path: '/login*',
      load: () => import(/* webpackChunkName: 'login' */ './login'),
      exportName: 'redirectToAccount',
    },
    {
      path: '/logout',
      load: () => import(/* webpackChunkName: 'logout' */ './logout'),
    },
    {
      path: '/about-us',
      load: () => import(/* webpackChunkName: 'aboutUs' */ './aboutUs'),
    },
    {
      path: '/careers',
      children: [
        {
          path: '',
          load: () => import(/* webpackChunkName: 'careers' */ './careers'),
        },
      ],
    },
    {
      path: '/for-providers',
      load: () => import(/* webpackChunkName: 'forProviders' */ './forProviders'),
      tabId: LOGGED_OUT_FOR_PROVIDERS_VIEW,
    },
    {
      path: '/for-providers/telemedicine',
      load: () => import(/* webpackChunkName: 'telemedicine' */ './forProviders/telemedicine'),
      tabId: LOGGED_OUT_FOR_PROVIDERS_VIEW,
    },
    {
      path: '/book-online/confirm',
      load: () => import(/* webpackChunkName: 'bookingWidgetConfirm' */ './booking-widget/confirm'),
    },
    {
      path: '/book-online/:locationId',
      load: () => import(/* webpackChunkName: 'bookingWidget' */ './booking-widget'),
    },
    {
      path: '/submitBooking',
      load: () => import(/* webpackChunkName: 'submitBooking' */ './submitBooking'),
    },
    {
      path: '/paperwork',
      children: [
        {
          path: '/start/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkStartFlow',
        },
        {
          path: '/patient/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkPatientFlow',
        },
        {
          path: '/employer/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkEmployerFlow',
        },
        {
          path: '/payment/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkPaymentFlow',
        },
        {
          path: '/guardian/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkGuardianFlow',
        },
        {
          path: '/emergency-contact/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkEmergencyContactFlow',
        },
        {
          path: '/custom/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkCustomFlow',
        },
        {
          path: '/consent/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkConsentFlow',
        },
        {
          path: '/finalize/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkFinalizeFlow',
        },
        {
          path: '/complete/:id',
          load: () => import(/* webpackChunkName: 'paperwork' */ './paperwork'),
          exportName: 'paperworkCompleteFlow',
        },
      ],
    },
    {
      path: '/payments',
      children: [
        {
          path: '/confirm/:invoiceId',
          load: () => import(/* webpackChunkName: 'payments' */ './payments'),
          exportName: 'confirmation',
        },
        {
          path: '/select/group/:groupId',
          load: () => import(/* webpackChunkName: 'payments' */ './payments'),
          exportName: 'select',
        },
        {
          path: '/select',
          load: () => import(/* webpackChunkName: 'payments' */ './payments'),
          exportName: 'select',
        },
        {
          path: '/select/**',
          load: () => import(/* webpackChunkName: 'payments' */ './payments'),
          exportName: 'select',
        },
        {
          path: '/create-invoice',
          load: () => import(/* webpackChunkName: 'payments' */ './payments'),
          exportName: 'createInvoice',
        },
        {
          path: '/add-card',
          load: () => import(/*webpackChunkName: 'addCard' */ './payments'),
          exportName: 'addCard',
        },
        {
          path: '/:invoiceId',
          load: () => import(/* webpackChunkName: 'payments' */ './payments'),
          exportName: 'payments',
        },
      ],
    },
    {
      path: '/share/:source',
      load: () => import(/* webpackChunkName: 'share' */ './tracking/share'),
      exportName: 'shareTracking',
    },
    {
      path: '/info/**',
      load: () => import(/* webpackChunkName: 'content' */ './content'),
    },
    {
      path: '/add-review/:id',
      load: () => import(/* webpackChunkName: 'addReview' */ './addReview'),
    },
    {
      path: '/review-on-google/:bookingId',
      load: () => import(/* webpackChunkName: 'reviewOnGoogle' */ './reviewOnGoogle'),
    },

    {
      path: '/mobile-check-in',
      children: [
        {
          path: '/start/:bookingId',
          load: () => import(/* webpackChunkName: 'mobileCheckIn' */ './mobileCheckIn'),
          exportName: 'mobileCheckInStart',
        },
        {
          path: '/success/:bookingId',
          load: () => import(/* webpackChunkName: 'mobileCheckIn' */ './mobileCheckIn'),
          exportName: 'mobileCheckInSuccess',
        },
        {
          path: '/skip/:bookingId',
          load: () => import(/* webpackChunkName: 'mobileCheckIn' */ './mobileCheckIn'),
          exportName: 'mobileCheckInSkip',
        },
      ],
    },
    {
      path: '/tos',
      tabId: LOGGED_OUT_ABOUT_VIEW,
      children: [
        {
          path: '/solv',
          load: () => import(/* webpackChunkName: 'tos' */ './tos'),
          exportName: 'consumerAppTos',
          tabId: LOGGED_OUT_ABOUT_VIEW,
        },
        {
          path: '/partner',
          load: () => import(/* webpackChunkName: 'tos' */ './tos'),
          exportName: 'widgetTos',
          tabId: LOGGED_OUT_ABOUT_VIEW,
        },
        {
          path: '/telemed',
          load: () => import(/* webpackChunkName: 'tos' */ './tos'),
          exportName: 'telemedTos',
          tabId: LOGGED_OUT_ABOUT_VIEW,
        },
        {
          path: '/hipaaconsent',
          load: () => import(/* webpackChunkName: 'tos' */ './tos'),
          exportName: 'hipaaConsentAuthorization',
          tabId: LOGGED_OUT_ABOUT_VIEW,
        },
        {
          path: '/financial-relationships',
          load: () => import(/* webpackChunkName: 'tos' */ './tos'),
          exportName: 'disclosureOfFinancialRelationships',
          tabId: LOGGED_OUT_ABOUT_VIEW,
        },
      ],
    },
    {
      path: '/book-group/:groupId',
      load: () => import(/* webpackChunkName: 'bookGroup' */ './bookGroup'),
      exportName: 'bookGroup',
    },
    {
      path: '/visit/:bookingId',
      load: () => import(/* webpackChunkName: 'postVisitSummary' */ './postVisitSummary'),
      exportName: 'postVisitSummaryRedirectUrl',
    },
    addYourAvailability,
    videoVisit,
    embed,
    redir,
    handoff,
    {
      path: '/walk-in-clinic',
      load: () => import(/* webpackChunkName: 'loadingScreen' */ './loadingScreen'),
    },
    cdp,
    {
      path: '/:shit([a-zA-Z0-9]{5})/:notShit(.*)',
      action: require('./goDaddyShit').default,
    },
    {
      path: '/500',
      load: () => import(/* webpackChunkName: '500' */ './error'),
    },
    {
      path: '*',
      load: () => import(/* webpackChunkName: '404' */ './404'),
    },
  ],

  async action({ next }) {
    return await next();
  },
};

export default routes;
